import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=05c180d8&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/classleasingtraffic.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c180d8')) {
      api.createRecord('05c180d8', component.options)
    } else {
      api.reload('05c180d8', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=05c180d8&", function () {
      api.rerender('05c180d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/App/Loader.vue"
export default component.exports